export function getHospitalsState(state) {
  return state.hospitals;
}
